import { useMemo, useState } from "react";

import { getExcelDataTypesConfig } from "./config";
import type { ExcelDataId } from "./types";

export const useExcelExportState = () => {
    const allIds = useMemo(() => getExcelDataTypesConfig().map((dataType) => dataType.id), []);
    const [selectedIds, setSelectedIds] = useState<Set<ExcelDataId>>(() => new Set(allIds));

    const isAllSelected = selectedIds.size === allIds.length;
    const isIndeterminate = selectedIds.size > 0 && selectedIds.size < allIds.length;

    const toggleAll = () => {
        setSelectedIds(isAllSelected ? new Set() : new Set(allIds));
    };

    const toggleItem = (id: ExcelDataId) => {
        setSelectedIds((prev) => {
            const next = new Set(prev);

            if (next.has(id)) {
                next.delete(id);
            } else {
                next.add(id);
            }

            return next;
        });
    };

    const resetSelection = () => {
        setSelectedIds(new Set(allIds));
    };

    return {
        selectedIds,
        isAllSelected,
        isIndeterminate,
        toggleAll,
        toggleItem,
        resetSelection,
    };
};
